import { LibraryCreatedProductOut, LibraryCreatedProductRequest } from '../../../../store/apiLibx';
import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';

export const uploadLocalContentProduct = (product: LibraryCreatedProductRequest & { id?: string }) => {
    const params = product.id ? { pathParams: { id: product.id } } : {};

    return http
        .post<LibraryCreatedProductOut>(`${localContentPrefix}/v1/localcontent/products/:id?`, product, params)
        .then(response => product.id ?? response.data.id!);
};
